import { createFileRoute } from '@tanstack/react-router';
import { PersonOverviewRoute } from './-route-wrappers';

/** The person profile's Overview tab at the profile's own URL (FPS-2690). */
function PersonOverviewIndexRoute() {
  return <PersonOverviewRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/')({
  component: PersonOverviewIndexRoute,
});
